import useBreakpoints from "neetocommons/react-utils/useBreakpoints";

import Dropdown from "./Dropdown";
import MenuButton from "./MenuButton";

const ProductSwitcher = ({ toggleModal }) => {
  const { isSize } = useBreakpoints();
  const isMobile = isSize("mobile");

  return isMobile ? (
    <MenuButton onClick={() => toggleModal(true)} />
  ) : (
    <Dropdown />
  );
};

export default ProductSwitcher;
